import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

export const motoPhotoImageUrl = (id) => `${API}/moto/photos/${id}/image`;
